import { Component, OnInit, Input } from '@angular/core';
import { ArgyleIncomeStream } from '../models/argyle';

@Component({
  selector: 'app-income-ver-1099-card',
  templateUrl: './income-ver-1099-card.component.html',
  styleUrls: ['./income-ver-1099-card.component.less']
})
export class IncomeVer1099CardComponent implements OnInit {
  @Input() incomeData: ArgyleIncomeStream;

  constructor() { }

  ngOnInit(): void {
  }

  // Helper methods for safe data access using actual Argyle field names
  getRecipientName(): string {
    try {
      return this.incomeData?.historicalData?.[0]?.metadata?.ocr_data?.forms?.[0]?.raw_fields?.['a_1099-nec-Part2-RecipientPii:recipientName']?.value || '-';
    } catch {
      return '-';
    }
  }

  getPayerName(): string {
    try {
      return this.incomeData?.historicalData?.[0]?.metadata?.ocr_data?.forms?.[0]?.raw_fields?.['a_1099-nec-Part1-PayerPii:payerName']?.value || '-';
    } catch {
      return '-';
    }
  }

  getTaxYear(): string {
    try {
      return this.incomeData?.historicalData?.[0]?.metadata?.ocr_data?.forms?.[0]?.raw_fields?.['a_1099-nec-General:forCalendarYear']?.value || '-';
    } catch {
      return '-';
    }
  }

  getNonEmployeeCompensation(): string {
    try {
      const value = this.incomeData?.historicalData?.[0]?.metadata?.ocr_data?.forms?.[0]?.raw_fields?.['a_1099-nec-Part3-LocalInfo:(box1)NonemployeeCompensation']?.value;
      return value ? `$${parseFloat(value).toFixed(2)}` : '-';
    } catch {
      return '-';
    }
  }

  getAuthenticityScore(): string {
    try {
      const score = this.incomeData?.historicalData?.[0]?.metadata?.ocr_authenticity_score;
      return score !== undefined ? score.toString() : '-';
    } catch {
      return '-';
    }
  }

  getMonthlyGrossAverage(): string {
    try {
      const monthly = this.incomeData?.summary?.monthlyGrossAverage;
      return monthly ? `$${monthly.toFixed(2)}` : '-';
    } catch {
      return '-';
    }
  }

  getDocumentStatus(): string {
    try {
      return this.incomeData?.status || 'Unknown';
    } catch {
      return 'Unknown';
    }
  }

  hasFraudAlerts(): boolean {
    try {
      const reasonCodes = this.incomeData?.historicalData?.[0]?.metadata?.ocr_authenticity?.doc_analysis?.[0]?.form_analysis?.[0]?.form_authenticity?.reason_codes;
      return reasonCodes && reasonCodes.length > 0;
    } catch {
      return false;
    }
  }

  getFraudAlerts(): any[] {
    try {
      return this.incomeData?.historicalData?.[0]?.metadata?.ocr_authenticity?.doc_analysis?.[0]?.form_analysis?.[0]?.form_authenticity?.reason_codes || [];
    } catch {
      return [];
    }
  }
}
